module.exports = __webpack_public_path__ + "img/halfstar.c447a5c0.svg";